import React from "react"
import { UrlService } from "../../../../core/services/UrlService"
import SelfTestResult from "./SelfTestResult"
import "./SelfTestSection.scss"
import $ from "jquery"

const SelfTestSection: React.FC<any> = (props: any) => {
    const [isSelected, setisSelected] = React.useState<any>([])
    const [result, setResult] = React.useState<string>("")
    const [shouldCheckResultDisable, setShouldCheckResultDisable] =
        React.useState<boolean>(false)

    React.useEffect(() => {
        for (let i = 0; i < props.questions.length; i++) {
            isSelected[i] = ""
        }
    }, [])

    const handleSelectAns = (index: string) => {
        if (isSelected[index] !== "Y") {
            const TmpList = [...isSelected]
            TmpList[index] = "Y"
            setisSelected(TmpList)
        } else {
            const TmpList = [...isSelected]
            TmpList[index] = ""
            setisSelected(TmpList)
        }
    }

    const handleSubmitResult = () => {
        for (let i = 0; i < props.questions.length; i++) {
            if (
                isSelected[3] === "Y" ||
                isSelected[4] === "Y" ||
                isSelected[5] === "Y"
            ) {
                setResult("Yellow")
                setShouldCheckResultDisable(true)
                break
            } else if (
                isSelected[6] === "Y" ||
                isSelected[7] === "Y" ||
                isSelected[8] === "Y" ||
                isSelected[9] === "Y"
            ) {
                setResult("Blue")
                setShouldCheckResultDisable(true)
                break
            } else if (
                isSelected[0] === "Y" ||
                isSelected[1] === "Y" ||
                isSelected[2] === "Y"
            ) {
                setResult("Green")
                setShouldCheckResultDisable(true)
                break
            } else if (
                isSelected[10] === "Y" ||
                isSelected[11] === "Y" ||
                isSelected[12] === "Y" ||
                isSelected[13] === "Y" ||
                isSelected[14] === "Y" ||
                isSelected[15] === "Y"
            ) {
                setResult("Purple")
                setShouldCheckResultDisable(true)
                break
            }
        }
    }

    return (
        <section>
            {!shouldCheckResultDisable ? (
                <>
                    <div className="self-test-questions_container">
                        <h2 className="self-test-questions_title">
                            回答以下問題以了解您是否有機會感染2019新型冠狀病毒(COVID-19)。（可選多於⼀項）<sup>3</sup>
                        </h2>
                        <div className="self-test-questions_content">
                            {props.questions.map(
                                (question: any, index: string) => {
                                    return (
                                        <div
                                            key={index}
                                            className={
                                                index < "3"
                                                    ? `self-test-questions_content-option fullwidth q${index}`
                                                    : `self-test-questions_content-option halfwidth q${index}`
                                            }
                                        >
                                            <label
                                                key={index}
                                                className={
                                                    isSelected[index] === "Y"
                                                        ? "option selected"
                                                        : "option"
                                                }
                                            >
                                                {question.icon ? (
                                                    <img
                                                        className="title-icon"
                                                        src={UrlService.getLocalImageUrl(
                                                            question.icon
                                                        )}
                                                        
                                                    />
                                                ) : (
                                                    <></>
                                                )}
                                                <div className="title-label">
                                                    {question.title}
                                                </div>
                                                <input
                                                    type="checkbox"
                                                    onClick={() => {
                                                        handleSelectAns(index)
                                                    }}
                                                    key={index}
                                                />
                                                <span className="checkmark">
                                                    <div className="checkmark_circle"></div>
                                                    <div className="checkmark_stem"></div>
                                                    <div className="checkmark_kick"></div>
                                                </span>
                                            </label>
                                        </div>
                                    )
                                }
                            )}
                        </div>
                        <span className="self-test-check-result_cta_button">
                            <span className="self-test-check-result_button-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="11"
                                    height="14"
                                    className="self-test-check-result_button-arrow"
                                >
                                    <path
                                        fill="currentColor"
                                        fillRule="evenodd"
                                        d="M0 0l11 7-11 7z"
                                    ></path>
                                </svg>
                            </span>
                            <div
                                className="self-test-check-result_label"
                                onClick={handleSubmitResult}
                            >
                                評估結果
                            </div>
                        </span>
                    </div>
                </>
            ) : (
                <SelfTestResult result={result} />
            )}
        </section>
    )
}

export default SelfTestSection
